module.exports = __webpack_public_path__ + "img/brochure_CR-thumbnail-circle.eb5cf02c.png";